module.exports = "sort-arrow-both"